export default `
  mutation trackProductEvents($events: AWSJSON!) {
    trackProductEvents(events: $events)
  }
`
